/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Regulation28BreachedDetailsViewModel
 */
export interface Regulation28BreachedDetailsViewModel {
    /**
     * 
     * @type {string}
     * @memberof Regulation28BreachedDetailsViewModel
     */
    classification?: string;
    /**
     * 
     * @type {number}
     * @memberof Regulation28BreachedDetailsViewModel
     */
    percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof Regulation28BreachedDetailsViewModel
     */
    percentageMinLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof Regulation28BreachedDetailsViewModel
     */
    percentageMaxLimit?: number;
}

/**
 * Check if a given object implements the Regulation28BreachedDetailsViewModel interface.
 */
export function instanceOfRegulation28BreachedDetailsViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function Regulation28BreachedDetailsViewModelFromJSON(json: any): Regulation28BreachedDetailsViewModel {
    return Regulation28BreachedDetailsViewModelFromJSONTyped(json, false);
}

export function Regulation28BreachedDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): Regulation28BreachedDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'classification': !exists(json, 'Classification') ? undefined : json['Classification'],
        'percentage': !exists(json, 'Percentage') ? undefined : json['Percentage'],
        'percentageMinLimit': !exists(json, 'PercentageMinLimit') ? undefined : json['PercentageMinLimit'],
        'percentageMaxLimit': !exists(json, 'PercentageMaxLimit') ? undefined : json['PercentageMaxLimit'],
    };
}

export function Regulation28BreachedDetailsViewModelToJSON(value?: Regulation28BreachedDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Classification': value.classification,
        'Percentage': value.percentage,
        'PercentageMinLimit': value.percentageMinLimit,
        'PercentageMaxLimit': value.percentageMaxLimit,
    };
}

